import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type PropsWithChildren } from 'react';
import { ApiError } from '@/api/client';

function makeClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // API-Antworten sind meist Trip-State, der sich live ändert — kurzer Stale-Cutoff.
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          // 401/403/404 nicht retryen — sind Endzustände, keine Transient-Fehler.
          if (error instanceof ApiError && (error.status === 401 || error.status === 403 || error.status === 404)) {
            return false;
          }
          return failureCount < 2;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}

export function AppProviders({ children }: PropsWithChildren) {
  const [client] = useState(() => makeClient());
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
